/**
 * @file: ExceptionSafetyIndex.
 * @authors: zhangkang.
 * @createDate: 2021/01/19.
 * @Description: 异常安全指数
 */
import request from '@/utils/request'

/**
 * 新增异常安全指数
 * @author: zhangkang
 * @createDate: 2021/01/19
 * @param data {Object} 参数
 */
export function exceptionSafetyindexAdd(data) {
  return request({
    type: 'device',
    url: 'exception/safetyindex/add',
    method: 'post',
    data
  })
}
/**
 * 删除异常安全指数
 * @author: zhangkang
 * @createDate: 2021/01/19
 * @param data {Object} 参数
 */
export function exceptionSafetyindexDelete(data) {
  return request({
    type: 'device',
    url: 'exception/safetyindex/delete',
    method: 'post',
    data
  })
}
/**
 * 获取异常安全指数详情
 * @author: zhangkang
 * @createDate: 2021/01/19
 * @param data {Object} 参数
 */
export function exceptionSafetyindexGet(data) {
  return request({
    type: 'device',
    url: 'exception/safetyindex/get',
    method: 'post',
    data
  })
}
/**
 * 异常安全指数列表(分页)
 * @author: zhangkang
 * @createDate: 2021/01/19
 * @param data {Object} 参数
 */
export function exceptionSafetyindexPageListGet(data) {
  return request({
    type: 'device',
    url: 'exception/safetyindex/page/list/get',
    method: 'post',
    data
  })
}
/**
 * 修改异常安全指数
 * @author: zhangkang
 * @createDate: 2021/01/19
 * @param data {Object} 参数
 */
export function exceptionSafetyindexUpdate(data) {
  return request({
    type: 'device',
    url: 'exception/safetyindex/update',
    method: 'post',
    data
  })
}


// WEBPACK FOOTER //
// ./src/api/ExceptionSafetyIndex.js